module.exports = __webpack_public_path__ + "static/img/296_TO8_1697_og.68e6447.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/296_TO8_1697_og.jpg
// module id = p6fN
// module chunks = 0